module.exports = __webpack_public_path__ + "img/emergency-modal.99d8b0ab.png";